module.exports = __webpack_public_path__ + "img/johnston-health-logo.08ad612c.jpg";